import type { UploadConnectionType, UploadFailureStage } from "./types";
import type { UploadFunnelAttempt } from "./uploadFunnel";

/**
 * An upload between `UploadSubmitted` and its outcome. Persisted on native so a
 * process death — the one failure the in-process funnel cannot report on, since
 * the code that would emit dies with it — is recovered at the next launch as
 * `UploadAbandoned`.
 */
export type InFlightUpload = {
  attempt: UploadFunnelAttempt;
  fileCount: number;
  totalSizeBytes?: number;
  startedAtMs: number;
  stage: UploadFailureStage;
  /**
   * Snapshotted at submit. Recovery-time radio would describe the next
   * launch, not the death, so abandon events reuse this rather than
   * re-reading NetInfo.
   */
  connectionType?: UploadConnectionType;
};

/**
 * Web is the no-op variant: recovery needs a process that comes back, and a
 * closed tab does not give us one. The real implementation lives in
 * `uploadLifecycle.native.ts`, which is what Metro resolves these imports to.
 */
export const trackInFlightUpload = (
  _uploadId: string,
  _upload: InFlightUpload,
): void => {};

export const updateInFlightUploadStage = (
  _uploadId: string,
  _stage: UploadFailureStage,
): void => {};

export const clearInFlightUpload = (_uploadId: string): void => {};

export const startUploadSessionLifecycle = async (): Promise<void> => {};
